import dayjs from 'dayjs'
import QuarterPlugin from 'dayjs/plugin/quarterOfYear'
import AdvancedFormatPlugin from 'dayjs/plugin/advancedFormat'
import CustomParsePlugin from 'dayjs/plugin/customParseFormat'

dayjs.extend(QuarterPlugin)
dayjs.extend(AdvancedFormatPlugin)
dayjs.extend(CustomParsePlugin)

const slices = {
  'type_invoices': {
    id: 'type_invoices',
    type: 'type',
    description: 'F',
    format: 'F'
  },

  'type_quotations': {
    id: 'type_quotations',
    type: 'type',
    description: 'D',
    format: 'D'
  },

  'type_year_YY': {
    id: 'type_year_YY',
    type: 'year',
    description: 'AA',
    regex: 'YY',
    format (date = new Date()) {
      return dayjs(date).format(this.regex)
    }
  }, 
  
  'type_year_YYYY': {
    id: 'type_year_YYYY',
    type: 'year',
    description: 'AAAA',
    regex: 'YYYY',
    format (date = new Date()) {
      return dayjs(date).format(this.regex)
    }
  },


  'type_count_XXXXX': {
    id: 'type_count_XXXXX',
    type: 'count',
    description: 'XXXXX',
    format (numero = 1) {
      return `${numero}`.length < 5 
              ? Array.apply(null, Array(5 - `${numero}`.length)).map(String.prototype.valueOf, '0').join('') + `${numero}`
              : numero
    }
  }, 

  'type_count_XXXX': {
    id: 'type_count_XXXX',
    type: 'count',
    description: 'XXXX',
    format (numero = 1) {
      return `${numero}`.length < 4 
              ? Array.apply(null, Array(4 - `${numero}`.length)).map(String.prototype.valueOf, '0').join('') + `${numero}`
              : numero
    }
  }, 

  'type_count_XXX': {
    id: 'type_count_XXX',
    type: 'count',
    description: 'XXX',
    format (numero = 1) {
      return `${numero}`.length < 3 
              ? Array.apply(null, Array(3 - `${numero}`.length)).map(String.prototype.valueOf, '0').join('') + `${numero}`
              : numero
    }
  }, 
  
  'type_count_XX': {
    id: 'type_count_XX',
    type: 'count',
    description: 'XX',
    format (numero = 1) {
      return `${numero}`.length < 2 
              ? Array.apply(null, Array(2 - `${numero}`.length)).map(String.prototype.valueOf, '0').join('') + `${numero}`
              : numero
    }
  }, 
  
  'type_count_X': {
    id: 'type_count_X',
    type: 'count',
    description: 'X',
    format (numero = 1) {
      return numero
    }
  },

  'type_month_MM': {
    id: 'type_month_MM',
    type: 'month',
    description: 'MM',
    regex: 'MM',
    format (date = new Date()) {
      return dayjs(date).format(this.regex)
    }
  },

  'type_day_DD': {
    id: 'type_day_DD',
    type: 'day',
    description: 'DD',
    regex: 'DD',
    format (date = new Date()) {
      return dayjs(date).format(this.regex)
    }
  }, 
  
  'type_client_2': {
    id: 'type_client_2',
    type: 'client',
    description: 'Première lettre du client',
    format (name = '') {
      return name.substr(0, 1).toUpperCase()
    }
  }, 
  
  'type_client_3': {
    id: 'type_client_3',
    type: 'client',
    description: '2 premières lettres du client',
    format (name = '') {
      return name.replace(/-/g, '').substr(0, 2).toUpperCase()
    }
  },

  'type_client_1': {
    id: 'type_client_1',
    type: 'client',
    description: '3 premières lettres du client',
    format (name = '') {
      return name.replace(/-/g, '').substr(0, 3).toUpperCase()
    }
  }, 
  
  'type_client_4': {
    id: 'type_client_4',
    type: 'client',
    description: 'Initiales du client',
    format (name = '') {
      return name.replace(/-/g, '').split(/\s/).map(w => w.substr(0, 1)).join('').toUpperCase()
    }
  },

  'type_custom_1': {
    id: 'type_custom_1',
    type: 'custom',
    description: 'Texte personnalisé',
    format: ''
  },

  'hyphen': {
    id: 'hyphen',
    type: 'separator',
    description: 'Tiret',
    format: '-'
  },

  'underscore': {
    id: 'underscore',
    type: 'separator',
    description: 'Underscore',
    format: '_'
  },
}

const types = {
  document_type: [
    slices.type_invoices,
    slices.type_quotations
  ],

  year: [
    slices.type_year_YY,
    slices.type_year_YYYY
  ],

  month: [
    slices.type_month_MM
  ],

  day: [
    slices.type_day_DD
  ],
  
  count: [
    slices.type_count_XXXX,
    slices.type_count_XXX,
    slices.type_count_XX,
    slices.type_count_X
  ],

  client: [
    slices.type_client_2,
    slices.type_client_3,
    slices.type_client_1,
    slices.type_client_4,
  ],

  custom: [
    slices.type_custom_1,
  ],

  separator: [
    slices.hyphen,
    slices.underscore,
  ]
}

const patterns = {
  invoices: [
    [
      slices.type_year_YYYY,
      slices.type_invoices,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_year_YY,
      slices.type_invoices,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_invoices,
      slices.type_year_YYYY,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_invoices,
      slices.type_year_YY,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_invoices,
      slices.hyphen,
      slices.type_year_YYYY,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_invoices,
      slices.hyphen,
      slices.type_year_YY,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_invoices,
      slices.type_count_XXX,
    ],
    [
      slices.type_year_YYYY,
      slices.type_count_XXX,
    ],
    [
      slices.type_year_YY,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_year_YY,
      slices.type_count_XXX,
    ],
    [
      slices.type_year_YYYY,
      slices.hyphen,
      slices.type_count_XXX,
    ],
  ],

  quotations: [
    [
      slices.type_year_YYYY,
      slices.type_quotations,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_year_YY,
      slices.type_quotations,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_quotations,
      slices.type_year_YYYY,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_quotations,
      slices.type_year_YY,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_quotations,
      slices.hyphen,
      slices.type_year_YYYY,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_quotations,
      slices.hyphen,
      slices.type_year_YY,
      slices.type_month_MM,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_quotations,
      slices.type_count_XXX,
    ],
    [
      slices.type_year_YYYY,
      slices.type_count_XXX,
    ],
    [
      slices.type_year_YY,
      slices.hyphen,
      slices.type_count_XXX,
    ],
    [
      slices.type_year_YY,
      slices.type_count_XXX,
    ],
    [
      slices.type_year_YYYY,
      slices.hyphen,
      slices.type_count_XXX,
    ],
  ],
}

const formatSlice = function (model, data = {}) {
  const options = Object.assign({
    numero: 1, 
    date: new Date(), 
    client: 'Client' 
  }, data)

  const slice = model.format ? model : slices[model.id]
  let value = '' 

  if (typeof slice.format === 'function') {
    const { client, numero, date } = options
    const params = []
    
    if (slice.type === 'client') {
      params.push(client)
    } else if (slice.type === 'count') {
      params.push(numero)
    } else {
      params.push(date)
    }

    value = slice.format(...params)
  } else {
    value = slice.format
  }

  return value
}

const setNumerotation = function (pattern, data = {}) {
  const options = Object.assign({
    numero: 1, 
    date: new Date(), 
    client: 'Client' 
  }, data)

  return pattern.map(slice => formatSlice(slice, options)).join('')
}

const refreshInterval = {
  month: 'monthly',
  monthly: 'monthly',
  year: 'yearly',
  yearly: 'yearly',
  never: 'never'
}

export {
  slices,
  types,
  patterns,
  formatSlice,
  refreshInterval,
  setNumerotation,
}

export default {
  slices,
  types,
  patterns,
  formatSlice,
  refreshInterval,
  setNumerotation,
}
